import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps & {
  onClick: () => void;
};

export const IconClose: FC<Props> = ({ className, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.3332 13.3334L2.6665 2.66669M13.3332 2.66669L2.6665 13.3334"
      stroke="#272756"
      strokeWidth="2.07704"
      strokeLinecap="round"
    />
  </svg>
);
